import {IoMdClose} from "react-icons/io";
import {useNavigate, useSearchParams} from "react-router-dom";
import ScoreCircle from "./ScoreCircle";
import QuizResultCard from "./QuizResultCard";
import {useEffect, useState} from "react";
import {Button, Divider, Spin} from "antd";
import useStore from "../../store/useStore";
import {getQuizResult} from "../tatvaPedia/service";
import { trackZymedEvent, ZYMED_EVENTS } from "../../utils/zymedAnalytics";

const questionVal = "Which organ is primarily responsible for detoxifying chemicals and metabolizing drugs in the body?";
const optionsVal = [
    {label: "Kidney", isCorrect: false, isSelected: true},
    {label: "Stomach", isCorrect: true, isSelected: false},
    {label: "Liver", isCorrect: false, isSelected: false},
    {label: "Pancreas", isCorrect: false, isSelected: false},
];
const QuizResult = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const {tatvaPediaToken} = useStore();
    const getToken = () =>
        tatvaPediaToken || localStorage.getItem("tatvaPediaToken");
    const token = getToken();
    const [quizId, setQuizId] = useState(searchParams.get('quizId'));
    const [userInfoId, setUserInfoId] = useState(searchParams.get('userInfoId'));
    const [contentInfoId, setContentInfoId] = useState(searchParams.get('contentInfoId'));
    const [quizResponse, setQuizResponse] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [backTo, setBackTo] = useState(searchParams.get('backTo'));
    // const []

    const backBtnHandler = () => {
        if (backTo === 'quiz-list')
            navigate('/tatvapedia/quiz-list?activeTab=finished', {state: {activeTab: 'finished'}, replace: true});
        navigate(-1);
    };

    const getQuizResponse = async () => {
        const res: any = await getQuizResult(quizId, userInfoId, token);
        if (res !== undefined) {
            console.log(res);
            trackZymedEvent(ZYMED_EVENTS.PEDIA_QUIZ_RESULT_VIEWED, {
                quiz_id: quizId,
                score: res?.body?.obtained_score,
            });
            setLoading(false);
            setQuizResponse(res?.body);
        }
    }

    useEffect(() => {
        getQuizResponse();
    }, []);

    return (
        <>
            <div className="flex flex-col h-screen">
                <div className="flex flex-row items-start bg-white p-6 sticky top-0 z-10">
                    <IoMdClose onClick={() => backBtnHandler()} className='mt-1 mr-2 font-medium cursor-pointer'/>
                    <span className={'font-medium'}>Your Result</span>
                </div>
                {loading ? <Spin className='items-center top-24'/> : <>
                    <div className="flex-1 bg-[#f5f5f5] px-4 overflow-y-auto">
                        <ScoreCircle passingScore={quizResponse?.passing_score} score={quizResponse?.obtained_score} total={quizResponse?.total_score}/>
                        <div className="mt-2 pb-32">
                            {quizResponse?.questions.map((v: any, i: any) =>
                                <QuizResultCard key={"card" + i} question={v?.question_text} options={v?.options}/>
                            )}
                        </div>
                    </div>
                    <div className="w-full bg-[#f5f5f5] sticky bottom-0 p-6 left-0 z-10">
                        <Divider/>
                        <div className={'flex flex-row justify-center gap-2 w-full'}>
                            <Button
                                onClick={backBtnHandler}
                                className="w-[85%] h-14  rounded-2xl bg-[#4B4AD5]  text-white p-5 text-lg font-medium"
                            >
                                Back to Home
                            </Button>
                        </div>
                    </div>
                </>}
            </div>
        </>
    );
};

export default QuizResult;